import { useCallback, useEffect, useState } from "react";

import api from "../../services/api";
import toastError from "../../errors/toastError";

// As contas conectadas, para as telas que precisam delas sem serem a tela de
// contas — publicar exige escolher a conta, e o aviso de "nenhuma conta
// conectada" precisa aparecer no lugar certo em vez de uma lista vazia sem
// explicação.
const useContasZernio = () => {
  const [contas, setContas] = useState([]);
  const [carregando, setCarregando] = useState(true);

  const carregar = useCallback(async () => {
    try {
      const { data } = await api.get("/zernio/accounts");
      setContas(data);
    } catch (err) {
      toastError(err);
    }

    setCarregando(false);
  }, []);

  useEffect(() => {
    carregar();
  }, [carregar]);

  return { contas, carregando, recarregar: carregar };
};

export default useContasZernio;
